import { isBefore, isFuture, isValid, parse, subMonths } from 'date-fns'
import { MedicalRequestPayload } from 'services/medicalRequest/createMedicalRequest'
import { MedicalAppointmentFormData } from './schema'
import InputValidation from 'utils/InputValidation'

const formatDate = (value: string): string => {

  const numbers = value.replace(/\D/g, '')


  if (numbers.length <= 2) return numbers
  if (numbers.length <= 4) return `${numbers.slice(0, 2)}/${numbers.slice(2)}`
  return `${numbers.slice(0, 2)}/${numbers.slice(2, 4)}/${numbers.slice(4, 8)}`
}

const parseDate = (date: string, dateFormat = 'dd/MM/yyyy'): Date => {
  return parse(date, dateFormat, new Date())
}

const isValidDate = (date: string): boolean => {
  if (!date || date.length !== 10) return false

  const parsedDate = parseDate(date)
  return isValid(parsedDate)
}

const isFutureDate = (date: string): boolean => {
  if (!isValidDate(date)) return false

  const parsedDate = parseDate(date)
  return isFuture(parsedDate)
}

const isWithinValidPeriod = (date: string): boolean => {
  if (!isValidDate(date)) return false

  const parsedDate = parseDate(date)
  const today = new Date()
  const sixMonthsAgo = subMonths(today, 6)

  return isBefore(sixMonthsAgo, parsedDate) && !isFuture(parsedDate)
}

const normalizeDate = (value: string): string => {
  const formattedDate = formatDate(value)

  if (formattedDate.length === 10) {
    return isValidDate(formattedDate) ? formattedDate : ''
  }

  return formattedDate
}

export const formatMedicalRequest = async (formData: MedicalAppointmentFormData, planCode: string): Promise<MedicalRequestPayload> => {
  const validation = new InputValidation(formData.documentFile, 'imageOrPdf')
  const imageIsValid = await validation.validate()
  const parsedDate = parse(formData.issueDate, 'dd/MM/yyyy', new Date())

  return {
    medical_request: imageIsValid.encodedFile,
    issue_date: parsedDate.toISOString().split('T')[0],
    cid_id: formData.cid[0]?.id || 0,
    professional_name: formData.professionalName,
    professional_document_number: formData.professionalDocumentNumber,
    professionaL_document_state: formData.professionalDocumentState[0]?.id || '',
    sessions: formData.sessionQuantity ? parseInt(formData.sessionQuantity, 10) : undefined,
    specialty_id: Number(formData.specialty[0]?.id || 0),
    plan_code: planCode,
  }
}

const formatters = {
  formatDate,
  normalizeDate,
  isValidDate,
  isFutureDate,
  isWithinValidPeriod,
  formatMedicalRequest
}

export default formatters
